import {notification} from "antd";
import {createSavedCompany} from "../utils/likedCompany/createSavedCompany";
import {deleteSavedCompany} from "../utils/likedCompany/deleteSavedCompany";

export const getHandleSaveCompany = (setCompanies) => {
    return (company, isMarket) => {
        const {company_inn: companyInn, company_name: companyName} = company;

        const updateCompanyList = (listSetter, valueSetter) => {
            listSetter(prev =>
                prev.map(c =>
                    c.company_inn === companyInn
                        ? {...c, [valueSetter]: true}
                        : c
                )
            );
        };

        if (!companyInn) {
            notification.warning({
                message: "Missing Company INN",
                description: "Cannot save this company because its INN is missing.",
                placement: "bottomRight",
            });
            return;
        }

        createSavedCompany({companyInn, isMarket})
            .then(({success, message}) => {
                if (message === "Company already liked by user") {
                    notification.info({
                        message: "Already Liked",
                        description: `${companyName} is already in your saved list.`,
                        placement: "bottomRight",
                        duration: 2.5,
                    });
                } else if (success) {
                    notification.success({
                        message: "Company Added",
                        description: `${companyName} has been added to your saved list.`,
                        placement: "bottomRight",
                        duration: 2.5,
                    });

                    updateCompanyList(
                        setCompanies,
                        isMarket ? "is_all_market_saved" : "is_saved"
                    );
                } else {
                    notification.error({
                        message: "Failed to Add",
                        description: `Could not add ${companyName}. Please try again.`,
                        placement: "bottomRight",
                        duration: 2.5,
                    });
                }
            })
            .catch((error) => {
                console.error("Error adding company:", error);
                notification.error({
                    message: "Server Error",
                    description: "Something went wrong. Try again later.",
                    placement: "bottomRight",
                    duration: 2.5,
                });
            });
    };
};

export function getHandleDeleteSaveCompany(setCompanies) {
    return async function handleDelete(company, isMarket) {
        const {company_inn: companyInn} = company;
        const fieldName = isMarket ? "is_all_market_saved" : "is_saved";

        // Optimistic UI update
        setCompanies((prevCompanies) =>
            prevCompanies.map((c) =>
                c.company_inn === companyInn
                    ? {...c, [fieldName]: false}
                    : c
            )
        );

        try {
            const success = await deleteSavedCompany({
                companyInn,
                isMarket
            });

            if (!success) {
                // Rollback if server failed
                setCompanies((prevCompanies) =>
                    prevCompanies.map((c) =>
                        c.company_inn === companyInn
                            ? {...c, [fieldName]: true}
                            : c
                    )
                );
            }
        } catch (error) {
            console.error("Delete saved company failed:", error);

            // Rollback on error
            setCompanies((prevCompanies) =>
                prevCompanies.map((c) =>
                    c.company_inn === companyInn
                        ? {...c, [fieldName]: true}
                        : c
                )
            );
        }
    };
}